const designVideo = (() => {
  const pageDesign = (document.getElementById("pageDesign") != null);
  if (pageDesign) {


    // let sW = window.innerWidth;
    // let sH = window.innerHeight;

    const videos = document.querySelectorAll('.js-design-video');
    const videoSubs = document.querySelectorAll('.js-design-video-sub');

    if (videos.length > 0 && videoSubs.length > 0) {

      videos.forEach((element, index) => {

        element
          .play()
          .then(() => {
            // play() が成功＝省電力モードではない
            console.log("省電力モードではありません");
          })
          .catch((error) => {
            // play() が失敗＝省電力モード
            videoSubs[index].classList.add('act');
          });
      });

    }



  }
})()
export default designVideo;